class SharedWithMe extends CollectionPanel {

	constructor(title: string, id?: number | string, sort?: string) {
		super(title);

		this.type = CollectionType.SharedWithMe;
		this.sort = sort;

		this.view();
		this.setUpEvents();
		this.getData(id);
	}
}